module.exports = {"321183002":"华阳街道","321183102":"下蜀镇","321183103":"白兔镇","321183104":"边城镇","321183105":"茅山镇","321183106":"后白镇","321183107":"郭庄镇","321183108":"天王镇","321183109":"宝华镇","321183400":"开发区","321183429":"茅山管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321183.json
// module id = 927
// module chunks = 0